import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  billToContainer: {
    marginRight: theme.spacing(0),
    minWidth: '360px',
  },

  discountInfoContainer: {
    alignSelf: 'start',
    flexGrow: 0,
    maxWidth: '360px',
  },
})
